var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"mb-1",attrs:{"no-gutters":""}},[_c('SalesAdder')],1),_c('v-card',[_c('v-card-text',[_c('SalesGrid',{attrs:{"loading":_vm.loading}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }